import React from 'react';
import PropTypes from 'prop-types';
import { Container, Navbar, Offcanvas } from 'react-bootstrap';
import { PREHEADER } from 'utils/sectionTypes';
import { BUILDER } from 'shared/abilities';
import { section } from '../decorators';
import style from './Preheader.scss';

const Preheader = ({ children }) => {
  const [facilitySearchBar] = React.Children.toArray(children);

  return (
    <Navbar className={`${style.root} color-tertiary-background`}>
      <Container>
        <Offcanvas.Header className={style.search}>
          {facilitySearchBar}
        </Offcanvas.Header>
      </Container>
    </Navbar>
  );
};

Preheader.propTypes = {
  children: PropTypes.node.isRequired,
};

const component = section(
  { name: 'Preheader: Search', region: PREHEADER, category: 'Preheader' },
  {
    subsections: [
      {
        accepts: [
          'FacilitySearchBar',
          'Button',
          'HeaderText',
          'SocialMediaIcons',
          'GoogleTranslate',
          'Breadcrumbs',
        ],
      },
    ],
    defaults: ['FacilitySearchBar'],
  },
)(Preheader);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
